import { isValidElement, ReactNode } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import Typography, { TypographyProps } from '@mui/material/Typography';

import BackButton from '../BackButton';

interface IPageTitleProps {
  title: ReactNode;
  showBackButton?: boolean;
  isLoading?: boolean;
  action?: ReactNode;
  disableTypography?: boolean;
  titleTypographyProps?: TypographyProps;
}

const PageTitleRoot = styled('header')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  marginBottom: theme.spacing(3.5),
  columnGap: theme.spacing(2),
}));

const PageTitleContent = styled('div')({});

const PageTitleAction = styled('div')({
  flex: '0 0 auto',
  alignSelf: 'flex-start',
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  alignItems: 'center',
});

export default function PageTitle({
  title: titleProp,
  showBackButton = false,
  isLoading = false,
  action,
  disableTypography,
  titleTypographyProps,
}: IPageTitleProps) {
  let title = titleProp;

  if ((isValidElement(title) ? title.type !== Typography : !!title) && !disableTypography) {
    title = (
      <Typography variant="h2" variantMapping={{ h2: 'h1' }} display="block" color="text.primary" {...titleTypographyProps}>
        {title}
      </Typography>
    );
  }

  return (
    <PageTitleRoot
      sx={{
        ...(Boolean(showBackButton || isLoading || action) && {
          gridTemplateColumns: `${showBackButton || isLoading ? 'min-content ' : ''}1fr ${action ? ' min-content' : ''}`,
        }),
      }}
    >
      {(showBackButton || isLoading) && <PageTitleAction>{isLoading ? <CircularProgress size={24} /> : <BackButton />}</PageTitleAction>}
      <PageTitleContent>{title}</PageTitleContent>
      {action && <PageTitleAction>{action}</PageTitleAction>}
    </PageTitleRoot>
  );
}
